import React, { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";
import { api, formatApiError } from "@/lib/api";
import { X } from "lucide-react";

export default function LeadPopup({ open, onClose }) {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", phone: "" });
  const [status, setStatus] = useState({ loading: false, ok: false, error: "" });

  useEffect(() => { if (open) setStatus({ loading: false, ok: false, error: "" }); }, [open]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, ok: false, error: "" });
    try {
      await api.post("/leads", { ...form, source: "popup_inspection" });
      setStatus({ loading: false, ok: true, error: "" });
      setTimeout(onClose, 1500);
    } catch (err) {
      setStatus({ loading: false, ok: false, error: formatApiError(err.response?.data?.detail) || err.message });
    }
  };

  return (
    <div data-testid="lead-popup" className="fixed inset-0 z-[80] grid place-items-center p-4">
      <div className="absolute inset-0 bg-onyx/85 backdrop-blur-md" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-charcoal border border-bone/10 p-8 lg:p-12 animate-fade-up">
        <button data-testid="lead-close" onClick={onClose} className="absolute top-4 right-4 text-bone/60 hover:text-brass">
          <X className="w-5 h-5" />
        </button>
        <div className="eyebrow mb-3">{t.leadpopup.eyebrow}</div>
        <h3 className="font-display text-3xl lg:text-4xl text-bone tracking-tight">
          <span className="italic-display text-brass">{t.leadpopup.title}</span>
        </h3>
        <p className="mt-4 text-bone/70 leading-relaxed">{t.leadpopup.lead}</p>

        <form onSubmit={submit} className="mt-8 space-y-2">
          <div>
            <label className="text-[0.65rem] tracking-[0.2em] uppercase text-taupe">{t.contact.name}*</label>
            <input data-testid="lead-name" required value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="field" />
          </div>
          <div>
            <label className="text-[0.65rem] tracking-[0.2em] uppercase text-taupe">{t.contact.phone}*</label>
            <input data-testid="lead-phone" required value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} className="field" />
          </div>
          {status.error && <div data-testid="lead-error" className="text-red-400 text-sm">{status.error}</div>}
          {status.ok && <div data-testid="lead-success" className="text-brass text-sm">{t.contact.sent}</div>}
          <button data-testid="lead-submit" type="submit" disabled={status.loading} className="btn-brass w-full justify-center mt-4">
            {status.loading ? "..." : t.leadpopup.btn}
          </button>
          <div className="text-center text-xs text-taupe pt-2">{t.leadpopup.foot}</div>
        </form>
      </div>
    </div>
  );
}
